var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnfoldMoreOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "orderBy",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 24,
    height: 24,
    fill: "#334856",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_621",
    "data-name": "Trac\\xE9 621",
    d: "M4.59,15.17,1.42,12,.01,13.41,4.59,18l4.59-4.59L7.76,12ZM4.59,0,0,4.59,1.42,6,4.59,2.83,7.76,6,9.17,4.59Z",
    transform: "translate(8 3)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfoldMoreOutlined);
export default __webpack_public_path__ + "static/media/UnfoldMoreOutlined.723a12a25f0ca4869c52d1358f1ca065.svg";
export { ForwardRef as ReactComponent };